import React, { ReactNode } from 'react';
import { spacing } from '../../styles/theme';
import H from '../elements/H';
import Paragraph from '../elements/Paragraph';
import {
  propToResponsivePropObject,
  ResponsiveProp
} from '../../utils/layoutUtils';
import IconText from './IconText';
import { IconName } from './Icon';

interface HeadingWithCountProps {
  icon: IconName;
  text: string;
  renderCount?: () => ReactNode;
  iconSize?: ResponsiveProp<number>;
}
const HeadingWithCount: React.FunctionComponent<
  HeadingWithCountProps & React.HTMLProps<HTMLDivElement>
> = ({ icon, text, renderCount, iconSize, ...rest }) => {
  const responsiveIconSize = propToResponsivePropObject(iconSize);
  return (
    <div {...rest}>
      <IconText
        icon={icon}
        iconSize={[
          responsiveIconSize.small || 3,
          responsiveIconSize.medium || 4,
          responsiveIconSize.large || 4
        ]}
      >
        <H styling="h4" tag="div">
          <strong className="icon-text">{text}</strong>
        </H>
        {renderCount && (
          <React.Fragment>
            &nbsp;
            <Paragraph tag="span" small data>
              <span className="count">{renderCount()}</span>
            </Paragraph>
          </React.Fragment>
        )}
      </IconText>
      {/*language=CSS*/}
      <style jsx>{`
        .count {
          line-height: ${spacing.two};
        }
        .icon-text {
          display: inline-block;
          padding-top: 2px;
        }
      `}</style>
    </div>
  );
};

export default HeadingWithCount;
